import usePrevious from './use-previous';

export default function useChanged<T>(value: T, initialize = true) {
  const prevVal = usePrevious(value, initialize);
  return prevVal !== value;
}
